module.exports = __webpack_public_path__ + "news_header.dc74736c0a7edac818b3.png";


//////////////////
// WEBPACK FOOTER
// /Users/ranjith/eclipse-workspace/monarch-web-contentful/src/assets/img/news_header.png
// module id = ../../../../../src/assets/img/news_header.png
// module chunks = styles